import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, CheckSquare, BellRing, Sparkles, ChevronRight } from 'lucide-react';

const EditorPage = () => {
  return (
    <div className="launcher-container page-fade">
      {/* Background Ambient Glows */}
      <div className="ambient-blur blur-blue"></div>
      <div className="ambient-blur blur-rose"></div>

      <div className="launcher-header">
        <div className="sparkle-badge animate-float">
          <Sparkles size={14} />
          <span>Productivity Hub</span>
        </div>
        <h1>Create Something</h1>
        <p>What's on your mind today?</p>
      </div>

      <div className="launcher-grid">
        <Link to="/notes" className="launcher-card note-card animate-pop">
          <div className="card-inner">
            <div className="icon-wrapper">
              <FileText size={26} />
              <div className="glow-ring"></div>
            </div>
            <div className="card-text">
              <h3>Notes</h3>
              <p>Capture thoughts & images</p>
            </div>
            <ChevronRight className="arrow-icon" size={18} />
          </div>
        </Link>

        <Link to="/tasks" className="launcher-card task-card animate-pop delay-1">
          <div className="card-inner">
            <div className="icon-wrapper">
              <CheckSquare size={26} />
              <div className="glow-ring"></div>
            </div>
            <div className="card-text">
              <h3>Tasks</h3>
              <p>Organize your daily goals</p>
            </div>
            <ChevronRight className="arrow-icon" size={18} />
          </div>
        </Link>

        <Link to="/reminders" className="launcher-card alarm-card animate-pop delay-2">
          <div className="card-inner">
            <div className="icon-wrapper">
              <BellRing size={26} />
              <div className="glow-ring"></div>
            </div>
            <div className="card-text">
              <h3>Alarms</h3>
              <p>Set time-sensitive alerts</p>
            </div>
            <ChevronRight className="arrow-icon" size={18} />
          </div>
        </Link>
      </div>
    </div>
  );
};

export default EditorPage;